import getDashboardStatus from "./dashboard/getDashboardStatus";
import getAllDocumentSubTypes from "./documentSubType/getAllDocumentSubTypes";
import getCheckAvailableDocumentSubType from "./documentSubType/getCheckAvailableDocumentSubType";
import deleteDocumentSubType from "./documentSubType/deleteDocumentSubType";
import postUpdateDocumentSubType from "./documentSubType/postUpdateDocumentSubType";
import putInsertDocumentSubType from "./documentSubType/putInsertDocumentSubType";

import getAllPaymentMethods from "./paymentMethod/getAllPaymentMethods.js.js";
import postUpdatePaymentMethod from "./paymentMethod/postUpdatePaymentMethod";

import getCustomerQuestionnaires from "./customerQuestionnaire/getCustomerQuestionnaires";
import putInsertCustomerQuestionnaire from "./customerQuestionnaire/putInsertCustomerQuestionnaire";
import postUpdateCustomerQuestionnaire from "./customerQuestionnaire/postUpdateCustomerQuestionnaire";
import deleteCustomerQuestionnaire from "./customerQuestionnaire/deleteCustomerQuestionnaire";

export const Models = {
  getDashboardStatus,
  getAllDocumentSubTypes,
  getCheckAvailableDocumentSubType,
  deleteDocumentSubType,
  postUpdateDocumentSubType,
  putInsertDocumentSubType,
  getAllPaymentMethods,
  postUpdatePaymentMethod,
  getCustomerQuestionnaires,
  putInsertCustomerQuestionnaire,
  postUpdateCustomerQuestionnaire,
  deleteCustomerQuestionnaire,
};
